import DOMPurify from 'dompurify';

// Strict config for email/HTML export — only safe inline elements & attributes
const EMAIL_CONFIG = {
  ALLOWED_TAGS: [
    'p','br','b','strong','i','em','u','s','del','ins',
    'h1','h2','h3','h4','h5','h6',
    'ul','ol','li',
    'a','span','div',
    'table','thead','tbody','tr','th','td',
    'img',
    'blockquote','pre','code',
  ],
  ALLOWED_ATTR: [
    'href','src','alt','title','style',
    'class','id','width','height',
    'cellpadding','cellspacing','border','align','valign',
    'colspan','rowspan',
  ],
  ALLOW_DATA_ATTR: false,
  FORCE_BODY: true,
};

// Preview config — a little more permissive (allows data-* for editor state)
const PREVIEW_CONFIG = {
  ...EMAIL_CONFIG,
  ALLOW_DATA_ATTR: true,
};

export function sanitizeHtml(html, mode = 'preview') {
  if (!html) return '';
  const config = mode === 'email' ? EMAIL_CONFIG : PREVIEW_CONFIG;
  return DOMPurify.sanitize(html, config);
}

export function sanitizeText(str) {
  if (!str) return '';
  return DOMPurify.sanitize(str, { ALLOWED_TAGS: [], ALLOWED_ATTR: [] });
}
